import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ApiService } from './api.service';
import { UserResponseDto } from '@qc/shared/dto';
import { UserRole } from '@qc/shared/enums';

@Injectable({ providedIn: 'root' })
export class AdminUserService extends ApiService {
    protected get basePath(): string {
        return '/admin/users';
    }

    getUsers(
        page = 1,
        limit = 10,
        searchTerm?: string,
        roleFilter?: UserRole | null,
    ): Observable<{
        users: UserResponseDto[];
        totalCount: number;
        totalPages: number;
    }> {
        const params: any = { page, limit };
        if (searchTerm) {
            params.search = searchTerm;
        }
        if (roleFilter) {
            params.role = roleFilter;
        }
        
        return this.getPaginated<UserResponseDto>('', params).pipe(
            map((response) => ({
                users: response.data,
                totalCount: response.meta.totalCount,
                totalPages: response.meta.totalPages,
            })),
        );
    }

    getUserDetails(userId: string): Observable<UserResponseDto> {
        return this.get<UserResponseDto>(userId).pipe(map((response) => response.data));
    }

    deleteUser(userId: string): Observable<{ message: string }> {
        return this.delete<{ message: string }>(userId).pipe(map((response) => response.data));
    }

    blockUser(userId: string): Observable<void> {
        return this.postVoid(`${userId}/block`);
    }

    unblockUser(userId: string): Observable<void> {
        return this.postVoid(`${userId}/unblock`);
    }

    assignUserRole(userId: string, role: UserRole): Observable<void> {
        return this.putVoid(`${userId}/role`, { role });
    }

    resetUserMfa(userId: string): Observable<{ message: string; deletedCount: number }> {
        return this.post<{ message: string; deletedCount: number }>(`${userId}/reset-mfa`, {}).pipe(
            map((response) => response.data),
        );
    }

    updateUser(
        userId: string,
        data: { firstName?: string; lastName?: string; email?: string },
    ): Observable<{ message: string }> {
        return this.put<{ message: string }>(userId, data).pipe(map((response) => response.data));
    }
}
